import { ReactNode } from 'react';
import { X, ChevronDown } from 'lucide-react';

interface BottomSheetProps {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  height?: 'auto' | 'half' | 'full';
  showHandle?: boolean;
  showHeader?: boolean;
}

export const BottomSheet = ({
  isOpen,
  onClose,
  title,
  children,
  height = 'auto',
  showHandle = true,
  showHeader = true
}: BottomSheetProps) => {

  const getHeightClass = () => {
    switch (height) {
      case 'full': return 'h-screen';
      case 'half': return 'h-[50vh]';
      default: return 'h-screen';
    }
  };

  return (
    <>
      {isOpen && (
        <>
          <div
            className="fixed inset-0 bg-base/80 backdrop-blur-sm z-modal-overlay"
            onClick={onClose}
          />

          <div
            className={`fixed bottom-0 left-0 right-0 z-modal-content bg-base shadow-2xl ${getHeightClass()}`}
          >
            <div className="flex flex-col h-full">
              <div className="flex-shrink-0">
                {showHandle && (
                  <div className="flex justify-center pt-3 pb-2">
                    <div className="w-12 h-1 bg-muted rounded-full" />
                  </div>
                )}
                {title && showHeader && (
                  <div className="flex items-center justify-between px-6 py-4 border-b border-subtle bg-base">
                    <h2 className="text-xl font-semibold text-th-primary">
                      {title}
                    </h2>
                    <button
                      onClick={onClose}
                      className="p-2.5 text-th-secondary hover:text-th-primary transition-colors rounded-xl hover:bg-overlay"
                    >
                      <X className="w-5 h-5" />
                    </button>
                  </div>
                )}
              </div>

              <div className="flex-1 overflow-y-auto">
                {children}
              </div>
            </div>

            {!title && (
              <button
                onClick={onClose}
                className="absolute top-4 right-4 p-2.5 text-th-secondary hover:text-th-primary transition-colors rounded-xl hover:bg-overlay"
              >
                <ChevronDown className="w-5 h-5" />
              </button>
            )}
          </div>
        </>
      )}
    </>
  );
};
